import { Cabin, GetOffersV2Response, TransportType, UpgradeProduct, UpgradeStatus, VoucherType } from '../api/models';

export const EF23GH: GetOffersV2Response = {
  booking: {
    passengers: [
      {
        passengerId: 'MSMARYBASIC',
        firstName: 'MARY',
        lastName: 'BASIC',
        title: 'MS',
        type: 'ADT',
        child: null,
        firstNameWithTitle: 'MARY MS',
        ordinal: 1,
      },
    ],
    flights: [
      {
        segmentInfo: {
          flightId: 'AY-1332-LHR-HEL-2023-03-15T10:20:00',
          group: 1,
          ordinal: 1,
          carrierCode: 'AY',
          flightNumber: '1332',
          boardPoint: 'LHR',
          offPoint: 'HEL',
          departureDateTimeLocal: '2023-03-15T10:20:00',
          departureDateTime: '2023-03-15T10:20:00.000+00:00',
          arrivalDateTimeLocal: '2023-03-15T15:15:00',
          arrivalDateTime: '2023-03-15T15:15:00.000+02:00',
          durationInMinutes: 175,
          longHaul: false,
          cabin: Cabin.Economy,
          travelClass: 'L',
          transportType: TransportType.Flight,
          segmentTattoo: '1',
        },
        upgrades: [
          {
            upgradeProductName: UpgradeProduct.EconomyToBusiness,
            isWaitlist: true,
            seatsAvailable: 0,
            travelClass: 'U',
            paymentOptions: {
              points: {
                price: 10000,
                priceWithLongHaul: 0,
              },
              UPGRADE_BENEFIT: {
                price: 1,
              },
            },
            upgradeStatus: UpgradeStatus.Available,
          },
        ],
      },
      {
        segmentInfo: {
          flightId: 'AY-61-HEL-HND-2023-03-15T17:55:00',
          group: 1,
          ordinal: 2,
          carrierCode: 'AY',
          flightNumber: '61',
          boardPoint: 'HEL',
          offPoint: 'HND',
          departureDateTimeLocal: '2023-03-15T17:55:00',
          departureDateTime: '2023-03-15T17:55:00.000+02:00',
          arrivalDateTimeLocal: '2023-03-16T14:25:00',
          arrivalDateTime: '2023-03-16T14:25:00.000+09:00',
          durationInMinutes: 810,
          longHaul: true,
          cabin: Cabin.Economy,
          travelClass: 'L',
          transportType: TransportType.Flight,
          segmentTattoo: '2',
        },
        upgrades: [
          {
            upgradeProductName: UpgradeProduct.EconomyToBusiness,
            isWaitlist: true,
            seatsAvailable: 0,
            travelClass: 'U',
            paymentOptions: {
              points: {
                price: 50000,
              },
            },
            upgradeStatus: UpgradeStatus.Available,
          },
          {
            upgradeProductName: UpgradeProduct.EconomyToPremiumeconomy,
            isWaitlist: false,
            seatsAvailable: 0,
            travelClass: 'F',
            paymentOptions: {},
            upgradeStatus: UpgradeStatus.NotAvailable,
          },
        ],
      },
      {
        segmentInfo: {
          flightId: 'AY-62-HND-HEL-2023-03-29T23:10:00',
          group: 2,
          ordinal: 1,
          carrierCode: 'AY',
          flightNumber: '62',
          boardPoint: 'HND',
          offPoint: 'HEL',
          departureDateTimeLocal: '2023-03-29T23:10:00',
          departureDateTime: '2023-03-29T23:10:00.000+09:00',
          arrivalDateTimeLocal: '2023-03-30T06:00:00',
          arrivalDateTime: '2023-03-30T06:00:00.000+03:00',
          durationInMinutes: 770,
          longHaul: true,
          cabin: Cabin.Economy,
          travelClass: 'L',
          transportType: TransportType.Flight,
          segmentTattoo: '3',
        },
        upgrades: [
          {
            upgradeProductName: UpgradeProduct.EconomyToBusiness,
            isWaitlist: true,
            seatsAvailable: 0,
            travelClass: 'U',
            paymentOptions: {
              points: {
                price: 50000,
              },
            },
            upgradeStatus: UpgradeStatus.Available,
          },
          {
            upgradeProductName: UpgradeProduct.EconomyToPremiumeconomy,
            isWaitlist: false,
            seatsAvailable: 0,
            travelClass: 'F',
            paymentOptions: {},
            upgradeStatus: UpgradeStatus.NotAvailable,
          },
        ],
      },
      {
        segmentInfo: {
          flightId: 'AY-1331-HEL-LHR-2023-03-30T08:00:00',
          group: 2,
          ordinal: 2,
          carrierCode: 'AY',
          flightNumber: '1331',
          boardPoint: 'HEL',
          offPoint: 'LHR',
          departureDateTimeLocal: '2023-03-30T08:00:00',
          departureDateTime: '2023-03-30T08:00:00.000+03:00',
          arrivalDateTimeLocal: '2023-03-30T09:10:00',
          arrivalDateTime: '2023-03-30T09:10:00.000+01:00',
          durationInMinutes: 190,
          longHaul: false,
          cabin: Cabin.Economy,
          travelClass: 'L',
          transportType: TransportType.Flight,
          segmentTattoo: '4',
        },
        upgrades: [
          {
            upgradeProductName: UpgradeProduct.EconomyToBusiness,
            isWaitlist: true,
            seatsAvailable: 0,
            travelClass: 'U',
            paymentOptions: {
              points: {
                price: 10000,
                priceWithLongHaul: 0,
              },
              UPGRADE_BENEFIT: {
                price: 1,
              },
            },
            upgradeStatus: UpgradeStatus.Available,
          },
        ],
      },
    ],
  },
  buyer: {
    email: 'ANCILLARYTEST@GMAIL.COM',
    points: 0,
    vouchers: [
      {
        type: VoucherType.EuropeUpgrade,
        count: 2,
      },
      {
        type: VoucherType.UpgradeBenefit,
        count: 2,
      },
    ],
  },
};
